import PageableBase from 'app/collections/pageable_base';
import { appUrl } from 'utils/wrappers';
import PaymentLog from 'app/models/payment_log';

export default PageableBase.extend({
  model: PaymentLog,
  key: 'payment_logs',
  url: appUrl('payment_logs'),

  initialize(models, { dateRange, sourceType, paymentMethods, staticParams = {}, pageSize }) {
    this.dateRange = dateRange;
    this.sourceType = sourceType;
    this.paymentMethods = paymentMethods;
    this.staticParams = staticParams;
    if (pageSize) this.state.pageSize = pageSize;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.sourceType, 'change', this.resetToFirstPage);
    this.listenTo(this.paymentMethods, 'charge', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.dateRange.getParams(),
      ...this.sourceType.getParams(),
      ...this.staticParams,
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/payment_logs.js